module.exports = {"451122100":"钟山镇","451122104":"回龙镇","451122105":"石龙镇","451122106":"凤翔镇","451122107":"珊瑚镇","451122108":"同古镇","451122109":"公安镇","451122111":"清塘镇","451122112":"燕塘镇","451122113":"红花镇","451122200":"花山瑶族乡","451122201":"两安瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451122.json
// module id = 1981
// module chunks = 0